interface IconProps {
    className?: string
}

export function CalendarIcon({ className }: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
        >
            <path
                clipRule="evenodd"
                d="M16.0005 2C15.4482 2 15 2.44772 15 3V5H9.001V3C9.001 2.44772 8.55278 2 8.0005 2C7.44822 2 7 2.44772 7 3V5H5C3.89543 5 3 5.89543 3 7V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V7C21 5.89543 20.1046 5 19 5H17.001V3C17.001 2.44772 16.5528 2 16.0005 2ZM5 20H19V11H5V20Z"
                fillRule="evenodd"
            />
        </svg>
    )
}
